export class UploadedCase {
  name: string;
  phone: string;
  email: string;
  gender: number;
  doctor: string;
  symptom: string;
  createTime: string;
  photo: any;

  constructor() {
    this.name = '';
    this.phone = '';
    this.email = '';
    this.gender = 2;
    this.doctor = '';
    this.symptom = '';
    this.createTime = '';
    this.photo = null;
  }
}

export class TongueDiagnosisDataDto {
  id: number; // 舌象診斷編號
  location: number; // 位置，1 = Center, 2 = Root, 3 = Front, 4 = Tip, 5 = Side
  pattern: string; // 中醫辨證
  symptomsMale: string; // 男性症狀
  symptomsFemale: string; // 女性症狀
  recommendation: string; // 建議
  chinesePattern: string; // 中文中醫辨證
  chineseSymptomsMale: string; // 中文男性症狀
  chineseSymptomsFemale: string; // 中文女性症狀
  chineseRecommendation: string; // 中文建議
  fiveElements: string[]; // 五行診斷
}

export class JsonTongue {
  id: number; // 舌象編號
  name: string; // 名稱
  chineseName: string; // 中文名稱
  chineseDescription: string; // 中文描述
  type: number; // 1 = 舌形、2 = 舌色、3 = 舌苔
  diagnosisList: TongueDiagnosisDataDto[]; // 診斷列表
  displayOrder: number; // 顯示順序，由 1 開始，不同 type 重新排序
  modTime: string; // 最後修改時間
  status: number; // 0 = 停用，1 = 啟用
  imageUrl: string; // 圖片網址
  segment: string;
}

export class SimpleTongueDto {
  id: number; // 舌象編號
  name: string; // 名稱
  type: number; // 1 = 舌形、2 = 舌色、3 = 舌苔
  imageUrl: string; // 舌象 Icon Url
  count: number; // 筆數
}

export class JsonTongueOrderList {
  type: number; // 1 = 舌形、2 = 舌色、3 = 舌苔
  ids: number[]; // 舌象編號列表，代表順序
}

export class JsonCaseTongue {
  locations: number[]; // 1 = Center, 2 = Root, 3 = Front, 4 = Tip, 5 = Side
  tongueType: number; // 舌象 type 1 = 舌形、2 = 舌色、3 = 舌苔
  tongue: ItemDto; // 標註的舌象
  tagger: TaggerDto; // 標註者
}

export class TaggerDto {
  id: number;
  name: string;
  color: string;
}

export class ItemDto {
  id: number; // 編號
  name: string; // 名稱
}

export class SimpleCaseDto {
  id: number; // 案例編號
  name: string; // 姓名
  doctorName: string; // 醫生名稱
  tongues: JsonCaseTongue[]; // 標註的舌象列表
  createTime: string; // 建立時間
  createTagger: ItemDto; // 建立舌象標記者
  lastTagger: ItemDto; // 最後舌象標記者
}

export class JsonCase {
  id: number; // 案例編號
  name: string; // 姓名
  email: string; // E-mail
  phone: string; // 電話
  gender: number; // 性別，1 = 男, 2 = 女
  doctor: ItemDto; // 醫生姓名
  symptom: string; // 症狀
  createTime: string; // 建立時間
  isSendMail: number; // 是否已送信，0 = 否、1 = 是
  token: string; // 查看案例 token
  tongues: JsonCaseTongue[]; // 標註的舌象列表
  imageUrl: string; // 案例圖片網址
  createTagger: ItemDto; // 建立舌象標記者
  lastTagger: ItemDto; // 最後舌象標記者
}

export class JsonCaseReport {
  id: number; // 案例編號
  name: string; // 姓名
  doctor: string; // 醫生姓名
  symptoms: string[]; // 症狀
  recommendation: string[]; // 建議
  tongues: JsonTongue[]; // 標註的舌象列表
}

export enum MemberRole {
  'admin' = 1,
  'doctor' = 2,
  'tagger' = 3
}

export class JsonLogin {
  id: number; // 成員編號
  account: string; // 成員帳號
  name: string; // 姓名
  role: number; // 角色
  color: string; // 代表顏色
  token: string; // 登入的jwt token
}

export class JsonMember {
  id: number; // 成員編號
  account: string; // 成員帳號
  password: string; // 密碼
  name: string; // 姓名
  role: number; // 角色
  status: number; // 0 = 停用，1 = 啟用
  color: string; // 顏色
}

export enum TudiErrorCode {
  'TudiInternalErrorException' = 1,
  'TudiAuthException' = 2,
  'TudiLoginException' = 3,
  'TudiBadRequestException' = 4,
  'TudiJsonException' = 7,
  'TudiDataNotFoundException' = 8
}

export class TudiException {
  errorcode: number;
  errormessage: string;
}

export enum TongueType {
  'Shape' = 1,
  'Color' = 2,
  'Coating' = 3
}

export enum TongueLocation {
  'Center' = 1,
  'Root' = 2,
  'Front' = 3,
  'Tip' = 4,
  'Left' = 5,
  'Right' = 6,
}

export enum FiveElement {
  'WoodLow' = 'WoodLow',
  'WoodHigh' = 'WoodHigh',
  'FireLow' = 'FireLow',
  'FireHigh' = 'FireHigh',
  'EarthLow' = 'EarthLow',
  'EarthHigh' = 'EarthHigh',
  'MetalLow' = 'MetalLow',
  'MetalHigh' = 'MetalHigh',
  'WaterLow' = 'WaterLow',
  'WaterFireLow' = 'WaterFireLow'
}

export class ResourceUrlDto {
  url: string;
}

export class TongueDiagnosisDto {
  tongueId: number; // 舌象編號
  tongueName: string; // 舌象名稱，簡體中文
  location: number; // 位置，1 = Center, 2 = Root, 3 = Front, 4 = Tip, 5 = Side
  symptoms: string[]; // 症狀描述，簡體中文
}

export enum TaggerType {
  'Admin' = 1,
  'AI' = 2
}

export class SegmentAreaDto {
  x1: number; // 切割區域的左上 x
  y1: number; // 切割區域的左上 y
  x2: number; // 切割區域的右下 x
  y2: number; // 切割區域的右下 y
  blockWidth: number; // 舌象九宮格每格的寬度
  blockHeight: number; // 舌象九宮格每格的高度
  topExpansionHeight: number; // 九宮格上方擴展空間的
  sideExpansionWidth: number; // 九宮格左右擴展空間的單邊寬度，左右各擴展九宮格範圍的 1/8
  status: number; // 1 = 成功, 2 = 舌頭太靠上面 (y1 為負), 3 = 舌頭太靠左 (x1 為負), 4 = 舌頭太靠右 (x2 超過原圖寬度), 9 = 辨識失敗
}

export class CaseSearchRequirementDto {
  fromDate?: string;
  toDate?: string;
  onlyMe?: number;
  name?: string;
  caseId?: number;
  tag: number;
  taggerId?: number;
  pageSize: number;
  pageNumber: number;

  constructor(fromDate?: string, toDate?: string, onlyMe?: number, name?: string, caseId?: number, tag: number = 2, taggerId?: number, pageSize: number = 25, pageNumber: number = 0) {
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.onlyMe = onlyMe;
    this.name = name;
    this.caseId = caseId;
    this.tag = tag;
    this.taggerId = taggerId;
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
  }
}

export class CountDto {
  count: number;
}

export class SpecificTongueCaseDtoLocationDto {
  location: number;
  tagger: TaggerDto;
}

export class SpecificTongueCaseDto {
  caseId: number;
  name: string;
  doctor: ItemDto;
  symptom: string;
  createTime: string;
  isTagged: number;
  locations: SpecificTongueCaseDtoLocationDto[];
  imageUrl: string;
}
